<template>
  <div>
    <div v-show="false"> {{getActionListCounter}} </div>
    <v-btn flat :color="ui.btnColor" @click="openImport()" :disabled="false">
      <v-icon left :color="ui.btnColor">
        {{item.btnIcon}}
      </v-icon>
      {{item.btnTitle}}
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :class="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-icon left color="wplblue0"> search </v-icon>
          <span :class="ui.textTitle">
            {{item.title}}
          </span>
        </v-card-title>
          <v-form ref="form" v-model="valid" v-on:submit.prevent="validate"
            lazy-validation>
            <v-container>
              <v-layout row>
                <v-flex xs10>
                  <v-text-field v-model="search.title"
                    :label="item.searchLabel1" :prepend-icon="item.searchIcon1">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap
              v-if="this.data.tag === 'G6'">
                <v-flex xs10>
                  <v-select
                    v-model="search.type"
                    :items="importTypesSearch"
                    label="relationship search"
                    color="wplblue0"
                    prepend-icon="category"
                    hint="relationship type"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <div v-if="this.getSearchResults !== null" class="mt-4">
                <v-layout row class="mr-3 ml-3">
                  <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
                    <v-data-table
                    :headers="headers"
                    :items="getSearchResults"
                    class="elevation-1"
                    :total-items=this.maxRows
                    :hide-actions=this.hideActions
                    >
                     <template slot="items" slot-scope="props">
                       <td class="text-xs-left">
                         {{ defineTableContent(props.item).item0 }}
                       </td>
                       <td class="text-xs-left">
                         {{ defineTableContent(props.item).item1 }}
                       </td>
                       <td class="text-xs-right">
                         <v-btn :color="ui.btnColor" dark icon small
                         v-if="props.item.basic.did !== getDetail.basic.did"
                          @click="importItem(props.item)"
                        >
                          <v-icon> add </v-icon>
                        </v-btn>
                       </td>
                     </template>
                   </v-data-table>
                 </v-flex>
                </v-layout>
              </div>
           </v-container>
           <v-layout  row>
             <v-btn
              @click="closeModal()"
              :color="ui.btnColor"
              flat
              >
               <v-icon left> exit_to_app </v-icon>
               Close
             </v-btn>
             <v-spacer/>
             <div v-if="this.enableSpinBtnSearch === false">
               <v-btn
                 flat
                 dark
                 :color="ui.btnColor"
                 :disabled="!this.enableSearch"
                 @click="searchBeforeImport(search)">
                 <v-icon left>search</v-icon>
                 search
               </v-btn>
             </div>
             <div v-else>
               <BtnSpin :btnSpec="btnInfo1"/>
             </div>
          </v-layout>
         </v-form>
    </v-card>

    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import announcements from "@/frame/messages/mixins/announcements.js";
import importOptions from "@/data/options/mixins/importOptions.js";
// import role from "@/data/forms/mixins/role.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import search from "@/data/search/mixins/search.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
// import actionFunctions from "@/business/actions/mixins/actionFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import limitEmbeddedList from "@/data/globals/mixins/limitEmbeddedList.js";
import relps from "@/data/forms/mixins/relps.js";

export default {
  // eslint-disable-next-line
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  // eslint-disable-next-line
  mixins: [
    search,
    announcements,
    apptheme,
    dataSources,
    docRevsModFunctions,
    listFunctions,
    importOptions,
    numberFunctions,
    relps,
    limitEmbeddedList
  ],
  data() {
    return {
      dialog: false,
      valid: false,
      importedOnePerSession: false,
      enableSpinBtnSearch: false,
      appendLimit: 10,
      maxRows: -1,
      hideActions: true,
      barMovement: false,
      search: {
        router: false,
        type: "Operations Notifications", // type of search
        id: "", // id for search
        title: "", // title for search
        ft: "", // faciluty title
        dbs: "" // data base source
      },
      enableSpinner: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        type: "icon"
      }
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetail",
      "getCurrentPage",
      "getSearchResults",
      "getRelationshipRegister",
      "getRelationshipRegisterCounter",
      "getAssetRegister",
      "getAssetRegisterCounter",
      "getRiskRegister",
      "getRiskRegisterCounter",
      "getFacilityRegister",
      "getFacilityRegisterCounter",
      "getMaterialRegister",
      "getMaterialRegisterCounter",
      "getEquipRegister",
      "getEquipRegisterCounter",
      "getHazardRegister",
      "getHazardRegisterCounter",
      "getFacility",
      "getActionList",
      "getActionListCounter"
    ]),
    enableSearch() {
      let logic = false;
      if (this.data.tag === "A1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "E1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "L1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "B1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "F1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "B3") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "G6") {
        if (this.search.type !== "" && this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      if (this.data.tag === "S1") {
        if (this.search.title !== "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      return logic;
    },
    item() {
      let obj = {
        title: "",
        searchLabel1: "",
        searchIcon1: "",
        importIcon: "",
        btnIcon: "download_for_offline",
        btnTitle: "import"
      };
      if (this.data.tag === "A1") {
        obj.title = "Asset Search and Import";
        obj.searchLabel1 = "asset name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "asset";
        obj.btnIcon = "add";
      } else if (this.data.tag === "E1") {
        obj.title = "Equipment Search and Import";
        obj.searchLabel1 = "equipment name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
      } else if (this.data.tag === "L1") {
        obj.title = "Materials Search and Import";
        obj.searchLabel1 = "part name";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "material";
        obj.btnIcon = "add";
      } else if (this.data.tag === "B1") {
        obj.title = "Risk Search and Import";
        obj.searchLabel1 = "risk title";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
      } else if (this.data.tag === "F1") {
        obj.title = "Facility Search and Import";
        obj.searchLabel1 = "facility title";
        obj.searchIcon1 = "title";
        obj.importIcon = "cloud";
        obj.btnTitle = "facility";
        obj.btnIcon = "add";
      } else if (this.data.tag === "B3") {
        obj.title = "Actions Search and Import";
        obj.searchLabel1 = "action name";
        obj.searchIcon1 = "title";
        obj.searchLabel2 = "action type";
        obj.searchIcon2 = "category";
        obj.importIcon = "cloud";
      } else if (this.data.tag === "G6") {
        obj.title = "Relationship Search and Import";
        obj.searchLabel1 = "relationship name";
        obj.searchIcon1 = "title";
        obj.searchLabel2 = "relationship type";
        obj.searchIcon2 = "category";
        obj.importIcon = "cloud";
      } else if (this.data.tag === "S1") {
        obj.title = "Hazard Search and Import";
        obj.searchLabel1 = "hazard name";
        obj.searchIcon1 = "title";
        obj.searchLabel2 = "hazard type";
        obj.searchIcon2 = "category";
        obj.importIcon = "cloud";
        obj.btnTitle = "Hazard";
        obj.btnIcon = "add";
      } else {
        obj.title = "Undefined";
      }
      return obj;
    },
    headers() {
      let head = [
        { text: "Undefind", sortable: false },
        { text: "Undefined", sortable: false },
        { text: "", sortable: false }
      ];
      if (this.data.tag === "A1") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "F1") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "B3") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      if (this.data.tag === "G6") {
        head[0].text = "ID";
        head[1].text = "Name";
      }
      if (this.data.tag === "S1") {
        head[0].text = "Tag";
        head[1].text = "Name";
      }
      return head;
    }
  },
  methods: {
    defineTableContent(item) {
      let obj = {
        item0: "", // this is id
        item1: "",
        item2: ""
      };
      if (this.data.tag === "A1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "E1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "F1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "L1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "B1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "B3") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "G6") {
        obj.item0 = this.defineIDGShortLastSix(item.basic.idg);
        obj.item1 = item.basic.title;
      } else if (this.data.tag === "S1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else {
        obj.item0 = "Undefined";
        obj.item1 = "Undefined";
      }
      return obj;
    },
    openImport() {
      this.dialog = true;
      this.enableSpinBtnSearch = false;
      this.$refs.form.reset();
      this.$store.dispatch("changeSearchResults", null);
      // reset search
      this.search.title = "";
      this.search.type = "";
    },
    reset() {
      this.$refs.form.reset();
    },
    closeModal() {
      this.dialog = false;
    },
    searchBeforeImport() {
      this.enableSpinBtnSearch = true;
      // Define search
      if (this.data.tag === "A1") {
        this.search.dbs = this.defineDataSourceFromTag(this.data.tag);
      } else if (this.data.tag === "E1") {
        this.search.dbs = this.defineDataSourceFromTag(this.data.tag);
      } else if (this.data.tag === "B1") {
        this.search.dbs = this.defineDataSourceFromTag(this.data.tag);
      } else if (this.data.tag === "F1") {
        this.search.dbs = this.defineDataSourceFromTag(this.data.tag);
      } else if (this.data.tag === "B3") {
        this.search.dbs = this.defineDataSourceFromTag(this.data.tag);
      } else if (this.data.tag === "L1") {
        this.search.dbs = this.defineDataSourceFromTag(this.data.tag);
      } else if (this.data.tag === "S1") {
        this.search.dbs = this.defineDataSourceFromTag(this.data.tag);
      } else if (this.data.tag === "G6") {
        if (this.search.type === "Operations Notifications") {
          this.search.dbs = this.defineDataSourceFromTag("O1");
        } else if (this.search.type === "Work Requests") {
          this.search.dbs = this.defineDataSourceFromTag("W1");
        } else if (this.search.type === "Engineering") {
          this.search.dbs = this.defineDataSourceFromTag("E2");
        } else if (this.search.type === "Risk Assessment") {
          this.search.dbs = this.defineDataSourceFromTag("B1");
        } else {
          this.search.dbs = null;
        }
      } else {
        this.search.dbs = null;
      }
      this.searchDocuments(this.search);
    },
    importItem(item) {
      this.importedOnePerSession = true;
      // INITIAL
      let tempList = [];
      let tempItem = this.formRelationshipItem;

      // SET ITEM
      tempItem.did = item.basic.did;
      tempItem.title = item.basic.title;
      tempItem.tag = item.basic.tag;
      tempItem.idg = item.basic.idg;
      tempItem.id = item.basic.id;

      if (this.data.tag === "A1") {
        // DEFINE LIST + ITEM
        tempItem.idi = this.getAssetRegisterCounter + 1;
        tempList = this.getAssetRegister;
        // ADD ITEM
        let obj = Object.assign({}, tempItem);
        let parseobj = JSON.parse(JSON.stringify(obj));
        let newList = this.appendItemLimitedwithDuplicateCheck(
          parseobj,
          tempList,
          this.assetRegisterImportLimit,
          "Asset"
        );
        // UPDATE LIST
        this.$store.dispatch("changeAssetRegister", newList);
        this.$store.dispatch("changeAssetRegisterCounter", tempItem.idi);
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.saveDocumentRevMod(3.14, 1); // business mod.
        // Announcements
        let msg = "New asset ";
        msg = msg + item.basic.title;
        msg = msg + " was added to Asset Register.";
        this.generateInfoSnackbar(this.ui.colorBlue1, msg);
      } else if (this.data.tag === "L1") {
        // DEFINE LIST + ITEM
        tempItem.idi = this.getMaterialRegisterCounter + 1;
        tempList = this.getMaterialRegister;
        // ADD ITEM
        let obj = Object.assign({}, tempItem);
        let parseobj = JSON.parse(JSON.stringify(obj));
        // eslint-disable-next-line
        let newList = this.appendItemLimitedwithDuplicateCheck(
          parseobj,
          tempList,
          this.materialRegisterImportLimit,
          "Material"
        );
        // UPDATE LIST
        this.$store.dispatch("changeMaterialRegister", newList);
        this.$store.dispatch("changeMaterialRegisterCounter", tempItem.idi);
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.saveDocumentRevMod(3.14, 1); // business mod.
        // Announcements
        let msg = "New material ";
        msg = msg + item.basic.title;
        msg = msg + " was added to BOM.";
        this.generateInfoSnackbar(this.ui.colorBlue1, msg);
      } else if (this.data.tag === "E1") {
        // DEFINE LIST + ITEM
        tempItem.idi = this.getEquipRegisterCounter + 1;
        tempList = this.getEquipRegister;
        // ADD ITEM
        let obj = Object.assign({}, tempItem);
        let parseobj = JSON.parse(JSON.stringify(obj));
        // eslint-disable-next-line
        let newList = this.appendItemLimitedwithDuplicateCheck(
          parseobj,
          tempList,
          this.equipmentRegisterImportLimit,
          "Equipment"
        );
        // UPDATE LIST
        this.$store.dispatch("changeEquipRegister", newList);
        this.$store.dispatch("changeEquipRegisterCounter", tempItem.idi);
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.saveDocumentRevMod(3.14, 1); // business mod.
        // Announcements
        let msg = "New equipment ";
        msg = msg + item.basic.title;
        msg = msg + " was added.";
        this.generateInfoSnackbar(this.ui.colorBlue1, msg);
      } else if (this.data.tag === "B1") {
        // DEFINE LIST + ITEM
        tempItem.idi = this.getRiskRegisterCounter + 1;
        tempList = this.getRiskRegister;
        // ADD ITEM
        let obj = Object.assign({}, tempItem);
        let parseobj = JSON.parse(JSON.stringify(obj));
        // eslint-disable-next-line
        let newList = this.appendItemLimitedwithDuplicateCheck(
          parseobj,
          tempList,
          this.riskRegisterImportLimit,
          "Risk"
        );
        // UPDATE LIST
        this.$store.dispatch("changeRiskRegister", newList);
        this.$store.dispatch("changeRiskRegisterCounter", tempItem.idi);
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.saveDocumentRevMod(3.14, 1); // business mod.
      } else if (this.data.tag === "S1") {
        // DEFINE LIST + ITEM
        tempItem.idi = this.getHazardRegisterCounter + 1;
        tempList = this.getHazardRegister;
        // ADD ITEM
        let obj = Object.assign({}, tempItem);
        let parseobj = JSON.parse(JSON.stringify(obj));
        // eslint-disable-next-line
        let newList = this.appendItemLimitedwithDuplicateCheck(
          parseobj,
          tempList,
          this.hazardRegisterImportLimit,
          "Hazard"
        );
        console.log("HELP");
        // UPDATE LIST
        this.$store.dispatch("changeHazardRegister", newList);
        this.$store.dispatch("changeHazardRegisterCounter", tempItem.idi);
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.saveDocumentRevMod(3.14, 1); // business mod.
        // Announcements
        let msg = "New Hazard ";
        msg = msg + item.basic.title;
        msg = msg + " was added to Hazard Register.";
        this.generateInfoSnackbar(this.ui.colorBlue1, msg);
      } else if (this.data.tag === "B3") {
        // DEFINE LIST + ITEM
        tempItem.idi = this.getActionListCounter + 1;
        tempList = this.getActionList;
        // ADD ITEM
        let obj = Object.assign({}, tempItem);
        let parseobj = JSON.parse(JSON.stringify(obj));
        // eslint-disable-next-line
        let newList = this.appendItemLimitedwithDuplicateCheck(
          parseobj,
          tempList,
          this.actionRegisterImportLimit,
          "Action"
        );
        // UPDATE LIST
        this.$store.dispatch("changeActionList", newList);
        this.$store.dispatch("changeActionListCounter", tempItem.idi);
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.saveDocumentRevMod(3.14, 1); // business mod.
      } else if (this.data.tag === "F1") {
        // DEFINE LIST + ITEM
        tempItem.idi = this.getFacilityRegisterCounter + 1;
        tempList = this.getFacilityRegister;
        // ADD ITEM
        let obj = Object.assign({}, tempItem);
        let parseobj = JSON.parse(JSON.stringify(obj));
        let newList = this.appendItemLimitedwithDuplicateCheck(
          parseobj,
          tempList,
          this.facilityRegisterImportLimit,
          "Facility"
        );
        // UPDATE LIST
        this.$store.dispatch("changeFacilityRegister", newList);
        this.$store.dispatch("changeFacilityRegisterCounter", tempItem.idi);
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.saveDocumentRevMod(3.14, 1); // business mod.
        // define temp item
        // if (this.getFacilityRegister !== null) {
        //   tempList = this.getFacilityRegister;
        //   // tempListRender = this.renderArrayofObjects(tempList);
        //   tempItem.idi = this.findIdiMax(tempList) + 1;
        //   // tempItem.idi = this.getRelationshipRegisterCounter + 1;
        // }
        // console.log("CHECK DUP PRIOR");
        // console.log(tempList);
        // // console.log(tempListRender);
        // console.log(tempItem);
        // // update temp
        // let oldList = this.getFacilityRegistert;
        // // eslint-disable-next-line
        // let duplicate = this.checkForDuplicateItemInList(tempItem, oldList);
        // if (duplicate === true) {
        //   // eslint-disable-next-line
        //   this.generateInfoSnackbar("error", "Duplicate Record or Single Entry.");
        // } else {
        //   let limit = this.appendLimit;
        //   let updatedList = null;
        //   updatedList = this.appendItemLimited(tempItem, tempList, limit);
        //   this.saveDocumentRevMod(4.16, 2); // relationship added
        //   this.$store.dispatch("changeFacilityRegister", updatedList);
        //   // eslint-disable-next-line
        //   this.$store.dispatch("changeFacilityRegisterCounter", tempItem.idi);
        //   this.$store.dispatch("changeDataSavePendingIndication", true);
        //   // this.dialog = false;
        //   // console.log(tempItem);
        // }
        // this.dialog = false;
      } else if (this.data.tag === "G6") {
        // define temp item
        if (this.getRelationshipRegister !== null) {
          tempList = this.getRelationshipRegister;
          tempItem.idi = this.findIdiMax(tempList) + 1;
          // tempItem.idi = this.getRelationshipRegisterCounter + 1;
        }
        // update temp
        let duplicate = this.checkForDuplicateItemInList(tempItem, tempList);
        if (duplicate === true) {
          this.generateInfoSnackbar("error", "Duplicate Record.");
        } else {
          let limit = this.appendLimit;
          let updatedList = null;
          updatedList = this.appendItemLimited(tempItem, tempList, limit);
          this.saveDocumentRevMod(4.16, 2); // relationship added
          this.$store.dispatch("changeRelationshipRegister", updatedList);
          // eslint-disable-next-line
          this.$store.dispatch("changeRelationshipRegisterCounter", tempItem.idi);
          this.$store.dispatch("changeDataSavePendingIndication", true);
          // this.dialog = false;
          // console.log(tempItem);
        }
      }
    }
  }
};
</script>
